import { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { Form, Input, Switch } from "antd";
import { CustomModal } from "../../components/Modals/CustomModal";
import "./InventarioAddNewStore.css";

export const InventarioAddNewStore = ({ visible, onClose, onSubmit, saving = false }) => {
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const handleOk = () => {
    if (saving) return;
    form.submit();
  };

  const handleCancel = () => {
    if (saving) return;
    form.resetFields(); // Limpia valores al cerrar
    onClose();
  };

  const onFinish = async (values) => {
    await onSubmit(values);
  };

  useEffect(() => {
    let timer;

    if (visible && inputRef.current) {
      timer = setTimeout(() => {
        inputRef.current.focus({ cursor: "end" });
      }, 200);
    }

    return () => clearTimeout(timer);
  }, [visible]);

  // Resetear formulario al cerrar el modal
  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleAfterOpen = (open) => {
    if (open) {
      inputRef.current?.input?.focus();
    }
  };

  return (
    <CustomModal
      visible={visible}
      title="Nuevo almacén"
      onClose={handleCancel}
      onOk={handleOk}
      okText={saving ? "Guardando..." : "Guardar"}
      cancelText="Cancelar"
      width="450px"
      afterOpenChange={handleAfterOpen}
      okButtonProps={{
        loading: saving,
        disabled: saving,
      }}
      cancelButtonProps={{
        disabled: saving,
      }}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        initialValues={{ storeName: "", status: true }}
        className="add-store-form"
      >
        <div className="add-store-form-row">
          <Form.Item
            name="storeName"
            label="Indique el nombre del Almacén"
            rules={[
              { required: true, message: "Ingrese nombre del almacén" },
              { min: 3, message: "Mínimo 3 caracteres" },
              { max: 50, message: "Máximo 50 caracteres" },
            ]}
            className="add-store-input-item"
          >
            <Input
              autoFocus
              ref={inputRef}
              placeholder="Ingrese nombre"
              className="add-store-input"
            />
          </Form.Item>

          <Form.Item
            name="status"
            label="Activo"
            valuePropName="checked"
            className="add-store-switch-item"
          >
            <Switch />
          </Form.Item>
        </div>
      </Form>
    </CustomModal>
  );
};

InventarioAddNewStore.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};
